import { render, staticRenderFns } from "./ArticleMetaItem.vue?vue&type=template&id=6265a517&"
import script from "./ArticleMetaItem.vue?vue&type=script&lang=js&"
export * from "./ArticleMetaItem.vue?vue&type=script&lang=js&"
import style0 from "./ArticleMetaItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports